/* This is used for local development and will get over written on builds with the correct env info */

import { AuthorizationConfig } from '../app/shared/models/authorization_config.model';
import { GeneralEnvironmentInfo } from '../app/shared/models/environment.model';

export const environment: AuthorizationConfig & GeneralEnvironmentInfo = {
  production: false,
  apiUrl: 'https://bppapi-tst.portal.arvest.com/api-bpp',
  logoutRedirectUrl: 'https://new17test.arvest.com/',
  userGuidePDF: 'https://bppapi-tst.portal.arvest.com/api-bpp/static/BPP_User_Guide.pdf',
  cmcUrl: 'https://arvestcentralmortgage.com',
  issuer_uri: 'https://login-test.portal.arvest.com',
  ping_end_session_endpoint: 'https://login-test.portal.arvest.com/idp/startSLO.ping',
  revocation_endpoint: 'https://login-test.portal.arvest.com/as/revoke_token.oauth2',
  client_id: "vuTdow4cMkAYHC7hU1I5",
  scope: 'openid profile',
  redirect_uri: 'https://bppapi-tst.portal.arvest.com/web-bpp/callback',
  base_uri: 'https://bppapi-tst.portal.arvest.com/web-bpp',
  extras: {
    ArvBrand: 'BPP',
  },
  webDirectUrl: 'http://www.arvest.com',
  maintenance: false,
  googleTagCode: 'GTM-NBZX8SB'
};
